import React from "react";
import { useAuthorizedOperator } from "contexts/AuthorizedOperatorContext";

const withAuthorizedOperator = (Component) => (props) => {
  const { operator } = useAuthorizedOperator();
  return <Component {...props} authorizedOperator={operator} />;
};

export default withAuthorizedOperator;
